<template>
    <div class="modal-mask" v-if="isShowOrderModal">
        <div class="borderModal">
            <!-- 关闭按钮 -->
            <img class="closed" @click="closeModal" src="@/assets/imgs/AutumnFestival/close.png" alt="关闭" />

            <div class="title">订单确认</div>

            <!-- 用户与金额信息框 -->
            <div class="info-group">
                <div class="username item">
                    <span class="label">兑换账号：</span>
                    <span class="value">{{ userInfo.username ? userInfo.username : '暂未获取' }}</span>
                </div>
                <div class="rechargeAmount item">
                    <span class="label">兑换金额：</span>
                    <span class="value"><span>{{ payParams.baseCoin }}</span> 白金币 💱 <span>{{ payParams.baseCoin
                    }}</span>
                        清凉币</span>
                </div>
            </div>

            <div class="titTxt" v-if="!payParams.firstBonusReceived">
                本次获得{{ payParams.baseCoin }}清凉币送{{ payParams.bonusCoin }}白金币（共得{{ payParams.baseCoin +
                    payParams.bonusCoin }}清凉币）
            </div>
            <div class="titTxt" v-else>
                本次获得{{ payParams.baseCoin }}清凉币
            </div>

            <div class="selectorMode">
                <div>
                    白金币剩余： {{ getActivityList.chargeMoney }}

                </div>
            </div>
 

            <div class="confirm" @click="goPay">确定兑换</div>
            <p class="confirmTxt">请仔细确认账单后兑换！</p>
 
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";

export default {
    name: 'pubMask',
    props: {
        isShowOrderModal: {
            type: Boolean,
            default: false
        },
        payParams: {
            type: Object,
        },
        getActivityList: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            userInfo: {},      
            loadingInstance: null, // 全局 Loading 实例存储 
            closed: require('@/assets/imgs/AutumnFestival/close.png'),
        };
    },
    mounted() { 
        const localUser = localStorage.getItem('userInfo');
        this.userInfo = localUser ? JSON.parse(localUser) : {};
    },
    methods: {
        // 发起支付
        goPay() { 
            if (this.payParams.baseCoin > this.getActivityList.chargeMoney) {
                this.$message.error('白金币不足');
                return;
            }
            // 1. 开启 Loading 加载蒙层
            this.loadingInstance = this.$loading({
                lock: true,
                text: '正在兑换...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            axios({
                method: 'post',
                url: '/pieceLotteryV2/exchangeCoin',
                headers: {
                    token: Cookies.get('wx_token'),
                },
                data: {
                    exchangeNum: this.payParams.baseCoin,  
                    platForm: 'web', 
                    userId: Cookies.get('wx_userId'),
                },
            }).then((res) => {
                let that = this;
                // 2. 接口响应后关闭 Loading
                if (that.loadingInstance) {
                    that.loadingInstance.close();
                }
                if (res.data.state === 200) {
                    that.$message.success('兑换成功！');
                    that.$emit('goPay');
                } else {
                    that.$message.error(res.data.message);
                }
            }).catch(err => {
                // 异常兜底：关闭 Loading
                if (this.loadingInstance) {
                    this.loadingInstance.close();
                }
                this.$message.error(err.message || '网络请求错误');
            });
        },
 

        // 清理定时器和 loading 遮罩
        clearTimers() {
            if (this.loadingInstance) {
                this.loadingInstance.close();
            }  
        },

        // 关闭弹窗
        closeModal() {
            this.clearTimers();
            this.$emit('closeModal');
        }
    },
    beforeDestroy() {
        // 组件销毁前兜底清理，防止定时器泄露及蒙层卡死
        this.clearTimers();
    }
};
</script>

<style lang="less" scoped>
/* 全屏半透明遮罩层 */
.modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
}

.borderModal {
    position: relative;
    width: 460px;
    background: #ffffff;
    border-radius: 16px;
    padding: 30px 40px;
    box-shadow: 0 10px 30px rgba(12, 85, 142, 0.2);
    border: 3px solid #85d5ff;

    .closed {
        position: absolute;
        top: -45px;
        right: -50px;
        width: 100px;
        height: 100px;
        cursor: pointer;
        transition: transform 0.2s;
        z-index: 10;

        &:hover {
            transform: rotate(90deg);
        }
    }

    .title {
        margin-bottom: 24px;
        text-align: center;
        font-size: 24px;
        color: #195280;
        font-weight: 700;
        letter-spacing: 1px;
    }

    .info-group {
        background: #f4faff;
        border-radius: 8px;
        padding: 10px 20px;
        margin-bottom: 16px;
    }

    .item {
        width: 100%;
        display: flex;
        align-items: center;
        margin: 10px 0;

        .label {
            font-size: 15px;
            font-weight: 600;
            color: #4a7596;
            width: 30%;
        }

        .value {
            width: 70%;
            font-size: 16px;
            font-weight: bold;
            color: #0c4169;

            span {
                font-size: 20px;
                font-weight: bold;
                color: #1a83ff;
            }
        }
    }

    .titTxt {
        width: 100%;
        height: 38px;
        margin: 15px auto;
        line-height: 38px;
        text-align: center;
        color: #ffffff;
        font-size: 15px;
        font-weight: bold;
        background: linear-gradient(90deg, #3db8ff, #1a83ff);
        border-radius: 20px;
        box-shadow: 0 4px 10px rgba(35, 147, 255, 0.3);
    }

    .selectorMode {
        margin: 20px 0;
        text-align: center;
        width: 100%;

        >div {
            display: inline-block;
            color: #ffffff;
            background-color: #ff197382;
            font-size: 16px;
            font-weight: 600;
            padding: 20px 10px;
            border-radius: 12px;
        }
    }
 

    .confirm {
        width: 200px;
        height: 44px;
        line-height: 44px;
        margin: 0 auto;
        background: linear-gradient(90deg, #36b5ff 0%, #0077ff 100%);
        border-radius: 22px;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
        box-shadow: 0 4px 12px rgba(0, 119, 255, 0.35);
        transition: transform 0.1s, box-shadow 0.2s;

        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 6px 16px rgba(0, 119, 255, 0.45);
        }

        &:active {
            transform: translateY(1px);
        }
    }

    .confirmTxt {
        text-align: center;
        font-size: 12px;
        color: #ff5252;
        margin-top: 10px;
    }
 
}
</style>
